<template>
  <v-content>    
    <auto-logout v-if="remember" />    
    <router-view />
    <content-footer />   
    <error-dialog />
  </v-content>
</template>

<script>
	import ContentFooter from './ContentFooter.vue'
  import AutoLogout from './AutoLogout.vue'   
  import ErrorDialog from './ErrorDialog.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'ContentView',
    components: {
      ContentFooter: ContentFooter,
      AutoLogout: AutoLogout,
      ErrorDialog: ErrorDialog
    },
    mounted(){
      let isRem = localStorage.getItem('remember')    
      isRem = (isRem ==="true")
      isRem = !isRem   
      this.remember = isRem
    },
    data() {
      return {
        remember: false
      }
    },
    computed: {
    ...mapGetters([
      'getRemember'     
		])
  }
  }
</script>

  